import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, makeStyles } from '@material-ui/core';
import ReactPlayer from 'react-player';
import usePage from '@/hooks/usePage.js';
import Request from '@/helpers/request.js';
import mainStyles from '@/assets/js/mainStyles.js';

const useStyles = makeStyles(mainStyles);

const Unfolding = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [module, setModule] = useState(null);
  const { setTitle } = usePage();

  useEffect(async () => {
    const fetchModule = async () => {
      const response = await Request.get(`/p3d2-modules/${id}`);
      setModule(response);
      setTitle('Dépliage');
    };
    await fetchModule();

    // Inject Google Analytics only on this page
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-06S5K2P40J';
    script.async = true;
    document.head.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-06S5K2P40J');
    `;
    document.head.appendChild(inlineScript);

    // Optional cleanup if needed
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, []);

  return (
    <Container maxWidth="md">
      <div className={classes.secTitle}>
        <span>{module?.usage?.unfolding?.title}</span>
      </div>
      <Box className={classes.descRoot}>
        {module?.usage?.unfolding && (
          <Box justifyContent={'center'} className={classes.videoBox}>
            <ReactPlayer url={module?.usage.unfolding.video} width="100%" height="100%" controls />
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default Unfolding;
